import Accordion from "@/common/components/Accordion";
import Alert from "@/common/components/Alert";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { maintenanceSpecificationDirectiveKlassLabel } from "@/features/establishmentLeadsFunnel/constants/maintenanceSpecificationDirectiveKlassLabel.constant";
import { MaintenanceSpecificationDirectiveKlass } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type";
import { AlertCircleIcon } from "lucide-react";
import CreateMaintenanceSpecificationModal from "./CreateMaintenanceSpecificationModal";
import MaintenanceSpecificationItem from "./MaintenanceSpecificationItem";

interface MaintenanceSpecificationsSectionProps {
  establishmentCompany: EstablishmentCompanyData;
  directiveKlass: MaintenanceSpecificationDirectiveKlass;
  alertText: {
    title: string;
    description: string;
  };
  disabled?: boolean;
}

const MaintenanceSpecificationsSection = ({
  establishmentCompany,
  directiveKlass,
  alertText,
  disabled,
}: MaintenanceSpecificationsSectionProps) => {
  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-3">
          <div onClick={(event) => {
            event.stopPropagation();
          }}>
            <CreateMaintenanceSpecificationModal
              establishmentCompany={establishmentCompany}
              directiveKlass={directiveKlass}
              alertText={alertText}
              disabled={disabled}
            />
          </div>

          <p className="text-lg font-bold">
            {maintenanceSpecificationDirectiveKlassLabel[directiveKlass]}
          </p>
        </div>
      )}
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="p-4 pt-0"
      body={(
        <div className="flex flex-col gap-4">
          <Alert
            variant="warning"
            Icon={AlertCircleIcon}
            containerClassName="bg-transparent p-0 flex-1"
          >
            <div className="flex flex-col">
              <p className="text-xs">
                {alertText.title}
              </p>

              <p className="text-xs italic font-light">
                {alertText.description}
              </p>
            </div>
          </Alert>

          {establishmentCompany?.maintenance_specifications
            ?.filter(({ directive_klass }) => directive_klass === directiveKlass)
            .map((maintenanceSpecification) => (
              <MaintenanceSpecificationItem
                key={maintenanceSpecification.id}
                establishmentCompany={establishmentCompany}
                maintenanceSpecification={maintenanceSpecification}
                alertText={alertText}
                disabled={disabled}
              />
            ))}
        </div>
      )}
    />
  );
}

export default MaintenanceSpecificationsSection;
